import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import {CheckoutContextProvider} from "@/components/context/CheckoutContext.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {AccountSubscriptionType} from "@/lib/types/accounts.ts";
import {Checkout as Checkout10} from "@/pages/billing/checkout/Checkout.tsx";
import {CheckoutPageContent as Checkout20} from "@/pages/billing/v2/checkout/CheckoutPageContent.tsx";

export const CheckoutPage = () => {
  const {user} = useCurrentUserContext();
  return (
    <ContentContainer title="Checkout">
      <Helmet>
        <title>Checkout</title>
      </Helmet>
      <Suspense>
        <UpErrorBoundary>
          <CheckoutContextProvider>
            {user?.account.subscription_type === AccountSubscriptionType.BILLING_2_0 ? <Checkout20 /> : <Checkout10 />}
          </CheckoutContextProvider>
        </UpErrorBoundary>
      </Suspense>
    </ContentContainer>
  );
};
